import React, {useEffect, useMemo} from "react";
import {RootState} from "../store/root-reducer";
import {useDispatch, useSelector} from "react-redux";
import {Layout} from "./ui-base/layout";
import {AuthService} from "../services/auth.service";
import {logged} from "../store/auth/auth-slice";
import axios from "axios";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import {hideSnackError, hideSnackSuccess} from '../store/global/global-slice';
import {FirstLoginLayout} from "./ui-base/first-login-layout";
import {Box, Typography} from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';
import styled from "styled-components";
import {Route, Switch, useHistory, useLocation, useParams} from "react-router-dom";
import LoginPage from "../pages/login";
import DashboardPage from "../pages/dashboard";
import RegisterPage from "../pages/register";
import RemindPasswordPage from "../pages/remind-password";
import ResetPasswordPage from "../pages/reset-password";
import AuthorProfilePage from "../pages/author/profile";
import AuthorEditProfilePage from "../pages/author/edit-profile";
import AuthorAddBookPage from "../pages/author/add-book";
import AuthorBooksListPage from "../pages/author/books";
import AuthorEditBookPage from "../pages/author/edit-book";
import AuthorDetailsBookPage from "../pages/author/details-book";
import AuthorPublishersBooksPage from "../pages/author/publishers-books";
import PublisherAllBooksPage from "../pages/publisher/books";
import PublisherProfile from "../pages/publisher/profile";
import PublisherEditProfilePage from "../pages/publisher/edit-profile";
import PublisherNotPublishListPage from "../pages/publisher/not-publish";
import PublisherToPublishListPage from "../pages/publisher/to-publish";
import PublisherDetailsBookPage from "../pages/publisher/details-book";
import FirstLoginPage from "../pages/first-login";
import ChangePasswordPage from "../pages/change-password";
import PublisherMarketPage from "../pages/publisher/market";
import {Colors} from "../theme/colors";
import PriceListPage from "../pages/publisher/price-list";
import PublisherEditProfileFirstTime from "../pages/publisher/edit-profile-first-time";
import PublisherEditDataProfilePage from "../pages/publisher/edit-data-profile";
import SimilarBooksToMyPage from "../pages/publisher/similar-books/similar-books-to-my";
import * as LogRocket from 'logrocket';
import BookViewPage from "../pages/book-view";
import {AuthMeModel} from "../models/auth-me.model";
import {AccountTypeEnum} from "../models/account-type.enum";
import {NotAccessModal} from "./ui-base/not-access-modal";
import PublisherForeignBooks from "../pages/publisher/foreign-books";
import i18n from "i18next";
import {loadCountries} from "../store/countries/countries-slice";
import {loadCategories, loadCsvCategories} from "../store/categories/categories-slice";
import {loadTags} from "../store/tags/tags-slice";
import PublisherSimilarBooksListPage from "../pages/publisher/similar-books/similar-books-list";
import PublisherSimilarBookCreatePage from "../pages/publisher/similar-books/similar-book-create";
import PublisherSimilarBookEditPage from "../pages/publisher/similar-books/similar-book-edit";
import PublisherMyBookCreatePage from "../pages/publisher/my-books/my-book-create";
import PublisherMyBooksListPage from "../pages/publisher/my-books/my-books-list";
import PublisherMyBookDetailsPage from "../pages/publisher/my-books/my-book-details";
import PublisherMyBookEditPage from "../pages/publisher/my-books/my-book-edit";
import PublisherMyBookAllProposals from "../pages/publisher/my-books/my-book-all-proposals";
import PublisherBooksPropositions from "../pages/publisher/books-propositions";
import PublisherBookPropositionDetails from "../pages/publisher/book-proposition-details";
import PublisherBookMarketPage from "../pages/publisher/book-market";
import {SuccessModal} from "./ui-base/success-modal";
import {useTranslation} from "react-i18next";
import {ConfirmEmailPage} from "../pages/confirm-email";

function CircularProgressWithLabel(props) {
    return (
        <Box sx={{position: 'relative', display: 'inline-flex'}}>
            <CircularProgress variant="determinate" size={150} style={{color: Colors.pink}} {...props} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography variant="caption" component="div"
                            style={{fontSize: '2rem', fontWeight: 'bold', color: Colors.lightViolet}}>
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}

const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const AuthorizationWrapper = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const token = AuthService.getToken();
    const urlParams = useParams();
    const publisherAlias = urlParams && ((urlParams['publisher']) as string || null);
    const {t} = useTranslation('common');
    const openUrls = useMemo(() => (
        ['/login', '/register', '/remind-password', '/reset-password', '/book-view/', '/email-activation/']
    ), []);
    let userLogged = useSelector(
        (state: RootState) => state.auth.logged
    );

    const authMe: AuthMeModel = useSelector(
        (state: RootState) => state.auth.user
    );

    const categoriesLoaded = useSelector(
        (state: RootState) => state.categories.categoriesLoaded
    );
    const tagsLoaded = useSelector(
        (state: RootState) => state.tags.tagsLoaded
    );

    const countriesLoaded = useSelector(
        (state: RootState) => state.countries.countriesLoaded
    );

    useEffect(() => {
        if (token && !userLogged) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

            AuthService.authMe().then((res) => {
                if (res) {
                    i18n.changeLanguage(res.language);
                    if (res.language === 'pl') {
                        axios.defaults.headers.common['Accept-Language'] = 'pl-PL';
                    } else {
                        axios.defaults.headers.common['Accept-Language'] = 'en-US';
                    }

                    dispatch(logged(res));
                    dispatch(loadCountries());
                    dispatch(loadCategories());
                    dispatch(loadCsvCategories());
                    dispatch(loadTags());

                    if (process.env.REACT_APP_USERBACK === 'false') {
                        LogRocket.identify(res.email, {
                            email: res.email,
                            subscriptionType: res.account_type
                        });
                    }

                    if (!publisherAlias && (openUrls.indexOf(location.pathname) !== -1 || location.pathname === '/')) {
                        history.push('/dashboard');
                    }

                    if (res.account_type === AccountTypeEnum.PUB) {

                    }
                } else {
                    axios.defaults.headers.common['Authorization'] = '';
                    AuthService.setToken('');
                    history.push('/login');
                }
            });
        } else if (!token) {
            if (openUrls.indexOf(location.pathname) === -1 && location.pathname.indexOf('/book-view/') === -1 && location.pathname.indexOf('/email-activation/') === -1) {
                history.push('/login');
            }
        }
    }, [userLogged, token, dispatch, history, location.pathname, publisherAlias, openUrls]);

    useEffect(() => {
        if (authMe && userLogged) {
            // Check if profile is complete, and redirect if not
            if (authMe.account_type === AccountTypeEnum.AUT) {
                const firstNameIncomplete = !authMe.author.first_name || authMe.author.first_name.trim() === '' || authMe.author.first_name === '-';
                const lastNameIncomplete = !authMe.author.last_name || authMe.author.last_name.trim() === '' || authMe.author.last_name === '-';
                const countryIncomplete = !authMe.author.country || authMe.author.country.trim() === '' || authMe.author.country === '-';
                if ((firstNameIncomplete || lastNameIncomplete || countryIncomplete) && !['/author/edit-profile'].includes(location.pathname)) {
                    history.push('/author/edit-profile');
                }
            }
        }
    }, [authMe, userLogged, location.pathname, history]);

    const snackError = useSelector(
        (state: RootState) => ({
            show: state.global.showSnackError,
            message: state.global.snackTextError
        })
    );

    const snackSuccess = useSelector(
        (state: RootState) => ({
            show: state.global.showSnackSuccess,
            message: state.global.snackTextSuccess
        })
    );

    const showLoader = useSelector(
        (state: RootState) => (state.global.showLoader)
    );

    const showProgress = useSelector(
        (state: RootState) => (state.global.showProgress)
    );

    const progressValue = useSelector(
        (state: RootState) => (state.global.progressValue)
    );

    const blockView = () => {
        return <SuccessModal open={true} setOpen={() => {
            history.push('/publisher/edit-profile-first-time');
        }} title={t('navbar.registrationSuccessModal.title')}
                             description={t('navbar.registrationSuccessModal.desc')}
                             buttonText={t('navbar.registrationSuccessModal.button')}
                             buttonLink={'/publisher/edit-profile-first-time'}/>;
    }

    const waitingForActivateView = () => {
        return <SuccessModal open={true} setOpen={async () => {
            history.push('/dashboard');
        }} title={t('navbar.waitingForActivate.title')}
                             description={t('navbar.waitingForActivate.desc')}
                             buttonText={t('navbar.waitingForActivate.button')}
                             buttonClick={async () => {
                                 await AuthService.logout();
                                 window.location.reload();
                             }}/>;
    }

    const notFoundPage = () => {
        return <SuccessModal open={true} setOpen={async () => {
            history.push('/dashboard');
        }} title={t('navbar.notFoundPage.title')}
                             description={t('navbar.notFoundPage.desc')}
                             buttonText={t('navbar.notFoundPage.button')}
                             buttonLink={'/dashboard'}/>;
    }

    return <>
        {((userLogged && (!categoriesLoaded || !tagsLoaded || !countriesLoaded)) || showLoader) &&
            <StyledLoader>
                <div style={{margin: '5rem auto 0', width: '130px'}}>
                    <CircularProgress size={130} />
                </div>
            </StyledLoader>
        }

        {showProgress &&
            <StyledProgress>
                <CircularProgressWithLabel value={progressValue}/>
            </StyledProgress>
        }
        <Snackbar open={snackError.show} autoHideDuration={6000} onClose={() => {
            dispatch(hideSnackError())
        }}>
            <Alert severity="error">
                {snackError.message}
            </Alert>
        </Snackbar>

        <Snackbar open={snackSuccess.show} autoHideDuration={6000} onClose={() => {
            dispatch(hideSnackSuccess())
        }}>
            <Alert severity="success">
                {snackSuccess.message}
            </Alert>
        </Snackbar>
        <Switch>
            <Route path="/first-login">
                {userLogged &&
                    <FirstLoginLayout>
                        <FirstLoginPage/>
                    </FirstLoginLayout>
                }
            </Route>
            <Route path="/login">
                <LoginPage/>
            </Route>
            <Route path="/register">
                <RegisterPage/>
            </Route>
            <Route path="/remind-password">
                <RemindPasswordPage/>
            </Route>
            <Route path="/reset-password">
                <ResetPasswordPage/>
            </Route>
            <Route path="/email-activation/:uid/:token">
                <ConfirmEmailPage/>
            </Route>
            <Route path="/book-view/:id">
                <BookViewPage/>
            </Route>

                <Route exact path="/dashboard" render={props => {
                    return <Layout userLogged={userLogged}>
                        <DashboardPage/>
                    </Layout>;
                }}>
                </Route>
                <Route path="/change-password">
                    <Layout userLogged={userLogged}>
                        <ChangePasswordPage/>
                    </Layout>
                </Route>
                <Route path="/author/profile">
                    <Layout userLogged={userLogged}>
                        <AuthorProfilePage/>
                    </Layout>
                </Route>
                <Route path="/author/edit-profile">
                    <Layout userLogged={userLogged}>
                        <AuthorEditProfilePage/>
                    </Layout>
                </Route>
                <Route path="/author/add-manuscript">
                    <Layout userLogged={userLogged}>
                        <AuthorAddBookPage/>
                    </Layout>
                </Route>
                <Route path="/author/edit-manuscript/:id">
                    <Layout userLogged={userLogged}>
                        <AuthorEditBookPage/>
                    </Layout>
                </Route>
                <Route path="/author/publishers/:id">
                    <Layout userLogged={userLogged}>
                        <AuthorPublishersBooksPage/>
                    </Layout>
                </Route>
                <Route path="/author/book/:id">
                    <Layout userLogged={userLogged}>
                        <AuthorDetailsBookPage/>
                    </Layout>
                </Route>
                <Route path="/author/books">
                    <Layout userLogged={userLogged}>
                        <AuthorBooksListPage/>
                    </Layout>
                </Route>
                <Route path="/publisher/profile" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherProfile/>
                        </Layout>;
                    }
                }}>
                </Route>

                <Route path="/publisher/similar-books/list" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && authMe.subscription.features.includes('similar_books')) {
                        return <Layout userLogged={userLogged}>
                            <PublisherSimilarBooksListPage/>
                        </Layout>;
                    } else {
                        return <NotAccessModal open={true}/>
                    }
                }}>
                </Route>

                <Route path="/publisher/similar-books/add" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && authMe.subscription.features.includes('similar_books')) {
                        return <Layout userLogged={userLogged}>
                            <PublisherSimilarBookCreatePage/>
                        </Layout>;
                    } else {
                        return <NotAccessModal open={true}/>
                    }
                }}>
                </Route>
                <Route path="/publisher/similar-books/edit/:id" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && authMe.subscription.features.includes('similar_books')) {
                        return <Layout userLogged={userLogged}>
                            <PublisherSimilarBookEditPage/>
                        </Layout>;
                    } else {
                        return <NotAccessModal open={true}/>
                    }
                }}>
                </Route>
                <Route path="/publisher/similar-books/details/:id" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && authMe.subscription.features.includes('similar_books')) {
                        return <Layout userLogged={userLogged}>
                            <SimilarBooksToMyPage/>
                        </Layout>;
                    } else {
                        return <NotAccessModal open={true}/>
                    }
                }}>
                </Route>
                <Route path="/publisher/similar-books/example/:id" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && authMe.subscription.features.includes('similar_books')) {
                        return <Layout userLogged={userLogged}>
                            <SimilarBooksToMyPage/>
                        </Layout>;
                    } else {
                        return <NotAccessModal open={true}/>
                    }
                }}>
                </Route>
                <Route path="/publisher/my-books/create" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherMyBookCreatePage/>
                        </Layout>;
                    }
                }}>
                </Route>
                <Route path="/publisher/my-books/list" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherMyBooksListPage/>
                        </Layout>;
                    }
                }}>
                </Route>
                <Route path="/publisher/my-books/details/:id" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherMyBookDetailsPage/>
                        </Layout>;
                    }
                }}>
                </Route>
                <Route path="/publisher/my-books/edit/:id" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else  {
                        return <Layout userLogged={userLogged}>
                            <PublisherMyBookEditPage/>
                        </Layout>;
                    }
                }}>
                </Route>
                <Route path="/publisher/my-books/publishers/:id" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherMyBookAllProposals/>
                        </Layout>;
                    }
                }}>
                </Route>
                <Route path="/publisher/book-proposition/:id" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherBookPropositionDetails/>
                        </Layout>;
                    }
                }}>
                </Route>
                <Route path="/publisher/books-propositions" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else  {
                        return <Layout userLogged={userLogged}>
                            <PublisherBooksPropositions/>
                        </Layout>;
                    }
                }}>
                </Route>
                <Route path="/publisher/foreign-books" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherForeignBooks/>
                        </Layout>;
                    }
                }}>

                </Route>
                <Route path="/publisher/edit-profile-data" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherEditDataProfilePage/>
                        </Layout>;
                    }
                }}>

                </Route>
                <Route path="/publisher/edit-profile" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherEditProfilePage/>
                        </Layout>;
                    }
                }}>
                </Route>
                <Route path="/publisher/edit-profile-first-time" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherEditProfileFirstTime/>
                        </Layout>;
                    }
                }}>

                </Route>
                <Route path="/publisher/manuscripts" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherAllBooksPage/>
                        </Layout>;
                    }
                }}>

                </Route>
                <Route path="/publisher/not-publish" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherNotPublishListPage/>
                        </Layout>;
                    }
                }}>
                </Route>
                <Route path="/publisher/to-publish" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherToPublishListPage/>
                        </Layout>;
                    }
                }}>
                </Route>
                <Route path="/publisher/manuscript/:id" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PublisherDetailsBookPage/>
                        </Layout>;
                    }
                }}>
                </Route>
                <Route path="/publisher/market" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && authMe.subscription.features.includes('market')) {
                        return <Layout userLogged={userLogged}>
                            <PublisherMarketPage/>
                        </Layout>;
                    } else {
                        return <NotAccessModal open={true}/>
                    }
                }}>
                </Route>

                <Route path="/publisher/book-market" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && authMe.subscription.features.includes('market')) {
                        return <Layout userLogged={userLogged}>
                            <PublisherBookMarketPage/>
                        </Layout>;
                    } else {
                        return <NotAccessModal open={true}/>
                    }
                }}>
                </Route>
                {/*NEXT*/}
                <Route path="/publisher/price-list" render={props => {
                    if (authMe?.account_type === AccountTypeEnum.PUB && authMe.status === 'AWAITING_FOR_VERIFICATION') {
                        return waitingForActivateView();
                    } else if (authMe?.account_type === AccountTypeEnum.PUB && !authMe.publisher) {
                        return blockView();
                    } else {
                        return <Layout userLogged={userLogged}>
                            <PriceListPage/>
                        </Layout>;
                    }
                }}>
                </Route>
                <Route path="*">
                    {notFoundPage()}
                </Route>

        </Switch>
    </>;
}

const StyledLoader = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  
  svg {
    color: ${Colors.secondary50};
  }
`;

const StyledProgress = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
`;
